
export default function SubscriptionPage(){
    return (
        <div>
            Subscription
        </div>
    )
}